import type { LucideIcon } from "lucide-react"
import type { ReactNode } from "react"

const FAN = ["-rotate-6 translate-x-4 translate-y-1", "z-10 -translate-y-1", "rotate-6 -translate-x-4 translate-y-1"]

/** Ghost nook cards, fanned when there are three: the shape of what will fill the screen. */
export function GhostCards({ icons }: { icons: LucideIcon[] }) {
  return (
    <div aria-hidden className="flex items-end justify-center">
      {icons.map((Icon, index) => (
        <div
          key={index}
          className={`bg-card flex h-24 w-20 flex-col gap-1.5 rounded-lg border p-2.5 shadow-sm ${icons.length === 3 ? FAN[index] : ""}`}
        >
          <Icon className="text-muted-foreground mb-auto size-4" />
          <div className="bg-muted h-1.5 w-full rounded-full" />
          <div className="bg-muted h-1.5 w-2/3 rounded-full" />
        </div>
      ))}
    </div>
  )
}

/** A screen with nothing to show: what happened, and the way out. */
export function EmptyState({
  art,
  title,
  description,
  action,
  children,
}: {
  art?: ReactNode
  title: string
  description: string
  action: ReactNode
  children?: ReactNode
}) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-5 px-6 py-16 text-center">
      {art}
      <div className="space-y-1.5">
        <h2 className="text-lg font-semibold tracking-tight">{title}</h2>
        <p className="text-muted-foreground max-w-sm text-sm">{description}</p>
      </div>
      {action}
      {children}
    </div>
  )
}
